import React from "react";
import useAuth from "../../Hooks/useAuth";
import Loading from "../Loading";

export function Logout() {
  const auth = useAuth();

  React.useLayoutEffect(() => {
    auth.logout();
  }, [auth]);

  return <Loading />;
}